export const APP_CLIENT_CONFIG = {
  main: {
    useCustomMap: false,
    loginBgType: 'main'
  },
  haerb: {
    useCustomMap: true,
    loginBgType: 'haerb'
  },
  jinzhong: {
    useCustomMap: false,
    loginBgType: 'jinzhong'
  }
}

const clientEnv = (import.meta.env.VITE_APP_CLIENT as keyof typeof APP_CLIENT_CONFIG) || 'main'
export const currentClientConfig = APP_CLIENT_CONFIG[clientEnv] || APP_CLIENT_CONFIG.main
